export const storageSetItem = (key, value) => {
  localStorage.setItem(key, value);
};

export const storageSetItemJsonValues = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const storageGetItem = (key) => {
  return localStorage.getItem(key);
};

export const storageGetItemJsonValues = (key) => {
  return JSON.parse(localStorage.getItem(key));
};

export const storageRemoveItem = (key) => {
  localStorage.removeItem(key);
};
export const clearStorage = () => {
  localStorage.clear();
};

export const removeState = () => {
  window.history.replaceState({}, document.title);
};
